import { mutatorAction } from 'satcheljs';
import { getComposeViewState } from 'owa-calendar-compose-store-manager';

const setCollabSpaceViewStateId = mutatorAction(
    'setCollabSpaceViewStateId',
    (viewStateId: string, formId: string) => {
        const viewState = getComposeViewState(formId);
        if (viewState) {
            viewState.collabSpaceViewStateId = viewStateId;
        }
    }
);

export { setCollabSpaceViewStateId as default };
